/*
 * File: cell-translation-job-error.ts
 * Created: 2026-02-05
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobError extends BaseTableBodyCell {
    get message(): string {
        const message = String(this.value ?? this.row?.errorMessage ?? "").trim();
        return message || this.$_("w_TranslationJobStatusFailed");
    }

    get reasonType(): "none" | "timeout" | "unsupported" | "critical" {
        const status = String(this.row?.errorStatus ?? "").toUpperCase();
        if (status === "NONE") return "none";
        if (status === "UNSUPPORTED") return "unsupported";
        if (status === "TIMEOUT") return "timeout";
        if (status === "CRITICAL") return "critical";
        return this.detectByMessage();
    }

    private detectByMessage(): "timeout" | "unsupported" | "critical" {
        const text = this.message.toLowerCase();
        if (
            text.includes("invalid office document") ||
            text.includes("invalid office") ||
            text.includes("unsupported file") ||
            text.includes("corrupt")
        ) {
            return "unsupported";
        }
        if (
            text.includes("dify request failed") ||
            text.includes("timeout") ||
            text.includes("timed out") ||
            text.includes("ecconn") ||
            text.includes("socket") ||
            text.includes(" 500") ||
            text.includes(" 502") ||
            text.includes(" 503") ||
            text.includes(" 504")
        ) {
            return "timeout";
        }
        return "critical";
    }

    get tagText(): string {
        if (this.reasonType === "none") return this.$_("w_TranslationJobStatusCompleted");
        if (this.reasonType === "timeout") return "ERR_TIMEOUT";
        if (this.reasonType === "unsupported") return "ERR_UNSUPPORTED";
        return "ERR_CRITICAL";
    }

    get reasonTitleKey(): string {
        if (this.reasonType === "none") return "w_TranslationJobStatusCompleted";
        if (this.reasonType === "timeout") return "w_TranslationJobFailReasonTimeoutTitle";
        if (this.reasonType === "unsupported") {
            return "w_TranslationJobFailReasonUnsupportedTitle";
        }
        return "w_TranslationJobFailReasonCriticalTitle";
    }

    get reasonDetailKey(): string {
        if (this.reasonType === "none") return "";
        if (this.reasonType === "timeout") return "w_TranslationJobFailReasonTimeoutDetail";
        if (this.reasonType === "unsupported") {
            return "w_TranslationJobFailReasonUnsupportedDetail";
        }
        return "w_TranslationJobFailReasonCriticalDetail";
    }

    get isOk(): boolean {
        return this.reasonType === "none";
    }
}
